import styles from './FindingBadge.module.css';

export function FindingBadge({
  kind,
  children,
  title,
}: {
  kind: 'discrepancy' | 'incomplete';
  children: React.ReactNode;
  title?: string;
}) {
  return (
    <span
      className={`${styles.badge} ${styles[kind]}`}
      title={title}
      role="img"
      aria-label={typeof children === 'string' ? children : `Finding: ${kind}`}
    >
      {children}
    </span>
  );
}
